import { ArrowUpRight } from "lucide-react";
import { waLink } from "../data/products";
import { useLang } from "../i18n";
import { FadeIn, MaskLine, Micro } from "./Reveal";

export default function Services() {
  const { t } = useLang();
  const items = t("services.items");
  return (
    <section id="services" data-testid="services-section" className="scroll-mt-24 px-5 md:px-12 py-24 md:py-36 border-t border-white/5">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12 md:mb-16">
        <div>
          <FadeIn>
            <Micro className="text-gold/80">{t("services.chapter")}</Micro>
          </FadeIn>
          <h2 className="font-display uppercase leading-[0.95] text-[clamp(2rem,5vw,4rem)] mt-5">
            <MaskLine delay={0.05}>{t("services.h1a")}</MaskLine>
            <MaskLine delay={0.15} innerClass="text-outline">{t("services.h1b")}</MaskLine>
          </h2>
        </div>
        <FadeIn delay={0.2}>
          <p className="text-sm md:text-base text-cream/50 max-w-xs">
            {t("services.p")}
          </p>
        </FadeIn>
      </div>

      <div>
        {items.map((s, i) => (
          <FadeIn key={s.name} delay={i * 0.08}>
            <a
              href={waLink(`Hi INT–EXT, I'd like to enquire about ${s.name}.`)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`service-${i}`}
              data-cursor="link"
              className={`group relative grid md:grid-cols-12 gap-4 md:gap-8 items-center px-4 md:px-8 py-9 md:py-12 border-t border-white/10 hover:bg-espresso/40 transition-colors duration-500 ${
                i === items.length - 1 ? "border-b" : ""
              }`}
            >
              <span className="absolute left-0 top-0 h-full w-[2px] bg-gold scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-500" />
              <div className="md:col-span-1 font-display text-gold text-sm tracking-[0.3em]">{String(i + 1).padStart(2, "0")}</div>
              <h3 className="md:col-span-6 font-display uppercase text-2xl md:text-4xl group-hover:text-gold transition-colors duration-500">
                {s.name}
              </h3>
              <p className="md:col-span-4 text-sm text-cream/50 leading-relaxed">{s.desc}</p>
              <ArrowUpRight className="hidden md:block md:col-span-1 w-5 h-5 justify-self-end text-cream/25 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500" />
            </a>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
